
  <ul class="nav flex-column nav-list" [class.disabled]="disabled">
        <ng-content *ngIf="!dataSource;else programmatic"></ng-content>
        <ng-template #programmatic ngFor let-item [ngForOf]="dataSource | async">
          <nalco-left-menu-item [id]="item.id" [text]="item.text" icon="item.icon" tooltip="item.tooltip" link="item.link"></nalco-left-menu-item>
        </ng-template>
      </ul>